@if (isTileLayout) {
  <div (scrolled)="onScrollDown()"
    [immediateCheck]="false"
    [infiniteScrollDisabled]="!isTileLayout || !moreMachinesAreAvailable"
    [infiniteScrollUpDistance]="1"
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="500"
    [scrollWindow]="false"
    [infiniteScrollContainer]="'.main-view'"
    [fromRoot]="true"
    class="grid-machines" infiniteScroll >
    @for (machine of shownMachines; track machine) {
      <scitis-dashboard-machine
        [availableMachineCategories]="availableMachineCategories"
        [currentMachineGroupId]="currentMachineGroupId"
        [currentUser]="user"
        [isViewerRole]="isViewerRole"
        [isAdminRole]="isAdminRole"
        [isAnalyticsRole]="isAnalyticsRole"
        [isSuperAdminRole]="isSuperAdminRole"
        [isWindowContentVisible]="isWindowContentVisible"
        [machine]="machine"
        [refreshInterval]="refreshInterval">
      </scitis-dashboard-machine>
    }
  </div>
}

